package me.tbsten.compose.preview.lab.extension.kotlinx.datetime

val mainTimeZones by lazy {
    mapOf(
        "UTC" to "UTC",

        // Asia
        "Asia/Tokyo" to "Asia/Tokyo",
        "Asia/Seoul" to "Asia/Seoul",
        "Asia/Shanghai" to "Asia/Shanghai",
        "Asia/Hong_Kong" to "Asia/Hong_Kong",
        "Asia/Singapore" to "Asia/Singapore",
        "Asia/Kolkata" to "Asia/Kolkata",
        "Asia/Dubai" to "Asia/Dubai",

        // Europe
        "Europe/London" to "Europe/London",
        "Europe/Paris" to "Europe/Paris",
        "Europe/Berlin" to "Europe/Berlin",
        "Europe/Rome" to "Europe/Rome",
        "Europe/Moscow" to "Europe/Moscow",

        // Americas
        "America/New_York" to "America/New_York",
        "America/Chicago" to "America/Chicago",
        "America/Denver" to "America/Denver",
        "America/Los_Angeles" to "America/Los_Angeles",
        "America/Sao_Paulo" to "America/Sao_Paulo",

        // Oceania
        "Australia/Sydney" to "Australia/Sydney",
        "Pacific/Auckland" to "Pacific/Auckland",
    )
}

val allTimeZones by lazy {
    mapOf(
        "Africa/Abidjan" to "Africa/Abidjan",
        "Africa/Accra" to "Africa/Accra",
        "Africa/Addis_Ababa" to "Africa/Addis_Ababa",
        "Africa/Algiers" to "Africa/Algiers",
        "Africa/Asmara" to "Africa/Asmara",
        "Africa/Bamako" to "Africa/Bamako",
        "Africa/Bangui" to "Africa/Bangui",
        "Africa/Banjul" to "Africa/Banjul",
        "Africa/Bissau" to "Africa/Bissau",
        "Africa/Blantyre" to "Africa/Blantyre",
        "Africa/Brazzaville" to "Africa/Brazzaville",
        "Africa/Bujumbura" to "Africa/Bujumbura",
        "Africa/Cairo" to "Africa/Cairo",
        "Africa/Casablanca" to "Africa/Casablanca",
        "Africa/Ceuta" to "Africa/Ceuta",
        "Africa/Conakry" to "Africa/Conakry",
        "Africa/Dakar" to "Africa/Dakar",
        "Africa/Dar_es_Salaam" to "Africa/Dar_es_Salaam",
        "Africa/Djibouti" to "Africa/Djibouti",
        "Africa/Douala" to "Africa/Douala",
        "Africa/El_Aaiun" to "Africa/El_Aaiun",
        "Africa/Freetown" to "Africa/Freetown",
        "Africa/Gaborone" to "Africa/Gaborone",
        "Africa/Harare" to "Africa/Harare",
        "Africa/Johannesburg" to "Africa/Johannesburg",
        "Africa/Juba" to "Africa/Juba",
        "Africa/Kampala" to "Africa/Kampala",
        "Africa/Khartoum" to "Africa/Khartoum",
        "Africa/Kigali" to "Africa/Kigali",
        "Africa/Kinshasa" to "Africa/Kinshasa",
        "Africa/Lagos" to "Africa/Lagos",
        "Africa/Libreville" to "Africa/Libreville",
        "Africa/Lome" to "Africa/Lome",
        "Africa/Luanda" to "Africa/Luanda",
        "Africa/Lubumbashi" to "Africa/Lubumbashi",
        "Africa/Lusaka" to "Africa/Lusaka",
        "Africa/Malabo" to "Africa/Malabo",
        "Africa/Maputo" to "Africa/Maputo",
        "Africa/Maseru" to "Africa/Maseru",
        "Africa/Mbabane" to "Africa/Mbabane",
        "Africa/Mogadishu" to "Africa/Mogadishu",
        "Africa/Monrovia" to "Africa/Monrovia",
        "Africa/Nairobi" to "Africa/Nairobi",
        "Africa/Ndjamena" to "Africa/Ndjamena",
        "Africa/Niamey" to "Africa/Niamey",
        "Africa/Nouakchott" to "Africa/Nouakchott",
        "Africa/Ouagadougou" to "Africa/Ouagadougou",
        "Africa/Porto-Novo" to "Africa/Porto-Novo",
        "Africa/Sao_Tome" to "Africa/Sao_Tome",
        "Africa/Tripoli" to "Africa/Tripoli",
        "Africa/Tunis" to "Africa/Tunis",
        "Africa/Windhoek" to "Africa/Windhoek",
        "America/Adak" to "America/Adak",
        "America/Anchorage" to "America/Anchorage",
        "America/Anguilla" to "America/Anguilla",
        "America/Antigua" to "America/Antigua",
        "America/Araguaina" to "America/Araguaina",
        "America/Argentina/Buenos_Aires" to "America/Argentina/Buenos_Aires",
        "America/Argentina/Catamarca" to "America/Argentina/Catamarca",
        "America/Argentina/Cordoba" to "America/Argentina/Cordoba",
        "America/Argentina/Jujuy" to "America/Argentina/Jujuy",
        "America/Argentina/La_Rioja" to "America/Argentina/La_Rioja",
        "America/Argentina/Mendoza" to "America/Argentina/Mendoza",
        "America/Argentina/Rio_Gallegos" to "America/Argentina/Rio_Gallegos",
        "America/Argentina/Salta" to "America/Argentina/Salta",
        "America/Argentina/San_Juan" to "America/Argentina/San_Juan",
        "America/Argentina/San_Luis" to "America/Argentina/San_Luis",
        "America/Argentina/Tucuman" to "America/Argentina/Tucuman",
        "America/Argentina/Ushuaia" to "America/Argentina/Ushuaia",
        "America/Aruba" to "America/Aruba",
        "America/Asuncion" to "America/Asuncion",
        "America/Atikokan" to "America/Atikokan",
        "America/Bahia" to "America/Bahia",
        "America/Bahia_Banderas" to "America/Bahia_Banderas",
        "America/Barbados" to "America/Barbados",
        "America/Belem" to "America/Belem",
        "America/Belize" to "America/Belize",
        "America/Blanc-Sablon" to "America/Blanc-Sablon",
        "America/Boa_Vista" to "America/Boa_Vista",
        "America/Bogota" to "America/Bogota",
        "America/Boise" to "America/Boise",
        "America/Cambridge_Bay" to "America/Cambridge_Bay",
        "America/Campo_Grande" to "America/Campo_Grande",
        "America/Cancun" to "America/Cancun",
        "America/Caracas" to "America/Caracas",
        "America/Cayenne" to "America/Cayenne",
        "America/Cayman" to "America/Cayman",
        "America/Chicago" to "America/Chicago",
        "America/Chihuahua" to "America/Chihuahua",
        "America/Ciudad_Juarez" to "America/Ciudad_Juarez",
        "America/Costa_Rica" to "America/Costa_Rica",
        "America/Creston" to "America/Creston",
        "America/Cuiaba" to "America/Cuiaba",
        "America/Curacao" to "America/Curacao",
        "America/Danmarkshavn" to "America/Danmarkshavn",
        "America/Dawson" to "America/Dawson",
        "America/Dawson_Creek" to "America/Dawson_Creek",
        "America/Denver" to "America/Denver",
        "America/Detroit" to "America/Detroit",
        "America/Dominica" to "America/Dominica",
        "America/Edmonton" to "America/Edmonton",
        "America/Eirunepe" to "America/Eirunepe",
        "America/El_Salvador" to "America/El_Salvador",
        "America/Fort_Nelson" to "America/Fort_Nelson",
        "America/Fortaleza" to "America/Fortaleza",
        "America/Glace_Bay" to "America/Glace_Bay",
        "America/Goose_Bay" to "America/Goose_Bay",
        "America/Grand_Turk" to "America/Grand_Turk",
        "America/Grenada" to "America/Grenada",
        "America/Guadeloupe" to "America/Guadeloupe",
        "America/Guatemala" to "America/Guatemala",
        "America/Guayaquil" to "America/Guayaquil",
        "America/Guyana" to "America/Guyana",
        "America/Halifax" to "America/Halifax",
        "America/Havana" to "America/Havana",
        "America/Hermosillo" to "America/Hermosillo",
        "America/Indiana/Indianapolis" to "America/Indiana/Indianapolis",
        "America/Indiana/Knox" to "America/Indiana/Knox",
        "America/Indiana/Marengo" to "America/Indiana/Marengo",
        "America/Indiana/Petersburg" to "America/Indiana/Petersburg",
        "America/Indiana/Tell_City" to "America/Indiana/Tell_City",
        "America/Indiana/Vevay" to "America/Indiana/Vevay",
        "America/Indiana/Vincennes" to "America/Indiana/Vincennes",
        "America/Indiana/Winamac" to "America/Indiana/Winamac",
        "America/Inuvik" to "America/Inuvik",
        "America/Iqaluit" to "America/Iqaluit",
        "America/Jamaica" to "America/Jamaica",
        "America/Juneau" to "America/Juneau",
        "America/Kentucky/Louisville" to "America/Kentucky/Louisville",
        "America/Kentucky/Monticello" to "America/Kentucky/Monticello",
        "America/Kralendijk" to "America/Kralendijk",
        "America/La_Paz" to "America/La_Paz",
        "America/Lima" to "America/Lima",
        "America/Los_Angeles" to "America/Los_Angeles",
        "America/Lower_Princes" to "America/Lower_Princes",
        "America/Maceio" to "America/Maceio",
        "America/Managua" to "America/Managua",
        "America/Manaus" to "America/Manaus",
        "America/Marigot" to "America/Marigot",
        "America/Martinique" to "America/Martinique",
        "America/Matamoros" to "America/Matamoros",
        "America/Mazatlan" to "America/Mazatlan",
        "America/Menominee" to "America/Menominee",
        "America/Merida" to "America/Merida",
        "America/Metlakatla" to "America/Metlakatla",
        "America/Mexico_City" to "America/Mexico_City",
        "America/Miquelon" to "America/Miquelon",
        "America/Moncton" to "America/Moncton",
        "America/Monterrey" to "America/Monterrey",
        "America/Montevideo" to "America/Montevideo",
        "America/Montserrat" to "America/Montserrat",
        "America/Nassau" to "America/Nassau",
        "America/New_York" to "America/New_York",
        "America/Nome" to "America/Nome",
        "America/Noronha" to "America/Noronha",
        "America/North_Dakota/Beulah" to "America/North_Dakota/Beulah",
        "America/North_Dakota/Center" to "America/North_Dakota/Center",
        "America/North_Dakota/New_Salem" to "America/North_Dakota/New_Salem",
        "America/Nuuk" to "America/Nuuk",
        "America/Ojinaga" to "America/Ojinaga",
        "America/Panama" to "America/Panama",
        "America/Paramaribo" to "America/Paramaribo",
        "America/Phoenix" to "America/Phoenix",
        "America/Port-au-Prince" to "America/Port-au-Prince",
        "America/Port_of_Spain" to "America/Port_of_Spain",
        "America/Porto_Velho" to "America/Porto_Velho",
        "America/Puerto_Rico" to "America/Puerto_Rico",
        "America/Punta_Arenas" to "America/Punta_Arenas",
        "America/Rankin_Inlet" to "America/Rankin_Inlet",
        "America/Recife" to "America/Recife",
        "America/Regina" to "America/Regina",
        "America/Resolute" to "America/Resolute",
        "America/Rio_Branco" to "America/Rio_Branco",
        "America/Santarem" to "America/Santarem",
        "America/Santiago" to "America/Santiago",
        "America/Santo_Domingo" to "America/Santo_Domingo",
        "America/Sao_Paulo" to "America/Sao_Paulo",
        "America/Scoresbysund" to "America/Scoresbysund",
        "America/Sitka" to "America/Sitka",
        "America/St_Barthelemy" to "America/St_Barthelemy",
        "America/St_Johns" to "America/St_Johns",
        "America/St_Kitts" to "America/St_Kitts",
        "America/St_Lucia" to "America/St_Lucia",
        "America/St_Thomas" to "America/St_Thomas",
        "America/St_Vincent" to "America/St_Vincent",
        "America/Swift_Current" to "America/Swift_Current",
        "America/Tegucigalpa" to "America/Tegucigalpa",
        "America/Thule" to "America/Thule",
        "America/Tijuana" to "America/Tijuana",
        "America/Toronto" to "America/Toronto",
        "America/Tortola" to "America/Tortola",
        "America/Vancouver" to "America/Vancouver",
        "America/Whitehorse" to "America/Whitehorse",
        "America/Winnipeg" to "America/Winnipeg",
        "America/Yakutat" to "America/Yakutat",
        "Antarctica/Casey" to "Antarctica/Casey",
        "Antarctica/Davis" to "Antarctica/Davis",
        "Antarctica/DumontDUrville" to "Antarctica/DumontDUrville",
        "Antarctica/Macquarie" to "Antarctica/Macquarie",
        "Antarctica/Mawson" to "Antarctica/Mawson",
        "Antarctica/McMurdo" to "Antarctica/McMurdo",
        "Antarctica/Palmer" to "Antarctica/Palmer",
        "Antarctica/Rothera" to "Antarctica/Rothera",
        "Antarctica/Syowa" to "Antarctica/Syowa",
        "Antarctica/Troll" to "Antarctica/Troll",
        "Antarctica/Vostok" to "Antarctica/Vostok",
        "Asia/Aden" to "Asia/Aden",
        "Asia/Almaty" to "Asia/Almaty",
        "Asia/Amman" to "Asia/Amman",
        "Asia/Anadyr" to "Asia/Anadyr",
        "Asia/Aqtau" to "Asia/Aqtau",
        "Asia/Aqtobe" to "Asia/Aqtobe",
        "Asia/Ashgabat" to "Asia/Ashgabat",
        "Asia/Atyrau" to "Asia/Atyrau",
        "Asia/Baghdad" to "Asia/Baghdad",
        "Asia/Bahrain" to "Asia/Bahrain",
        "Asia/Baku" to "Asia/Baku",
        "Asia/Bangkok" to "Asia/Bangkok",
        "Asia/Barnaul" to "Asia/Barnaul",
        "Asia/Beirut" to "Asia/Beirut",
        "Asia/Bishkek" to "Asia/Bishkek",
        "Asia/Brunei" to "Asia/Brunei",
        "Asia/Chita" to "Asia/Chita",
        "Asia/Choibalsan" to "Asia/Choibalsan",
        "Asia/Colombo" to "Asia/Colombo",
        "Asia/Damascus" to "Asia/Damascus",
        "Asia/Dhaka" to "Asia/Dhaka",
        "Asia/Dili" to "Asia/Dili",
        "Asia/Dubai" to "Asia/Dubai",
        "Asia/Dushanbe" to "Asia/Dushanbe",
        "Asia/Famagusta" to "Asia/Famagusta",
        "Asia/Gaza" to "Asia/Gaza",
        "Asia/Hebron" to "Asia/Hebron",
        "Asia/Ho_Chi_Minh" to "Asia/Ho_Chi_Minh",
        "Asia/Hong_Kong" to "Asia/Hong_Kong",
        "Asia/Hovd" to "Asia/Hovd",
        "Asia/Irkutsk" to "Asia/Irkutsk",
        "Asia/Jakarta" to "Asia/Jakarta",
        "Asia/Jayapura" to "Asia/Jayapura",
        "Asia/Jerusalem" to "Asia/Jerusalem",
        "Asia/Kabul" to "Asia/Kabul",
        "Asia/Kamchatka" to "Asia/Kamchatka",
        "Asia/Karachi" to "Asia/Karachi",
        "Asia/Kathmandu" to "Asia/Kathmandu",
        "Asia/Khandyga" to "Asia/Khandyga",
        "Asia/Kolkata" to "Asia/Kolkata",
        "Asia/Krasnoyarsk" to "Asia/Krasnoyarsk",
        "Asia/Kuala_Lumpur" to "Asia/Kuala_Lumpur",
        "Asia/Kuching" to "Asia/Kuching",
        "Asia/Kuwait" to "Asia/Kuwait",
        "Asia/Macau" to "Asia/Macau",
        "Asia/Magadan" to "Asia/Magadan",
        "Asia/Makassar" to "Asia/Makassar",
        "Asia/Manila" to "Asia/Manila",
        "Asia/Muscat" to "Asia/Muscat",
        "Asia/Nicosia" to "Asia/Nicosia",
        "Asia/Novokuznetsk" to "Asia/Novokuznetsk",
        "Asia/Novosibirsk" to "Asia/Novosibirsk",
        "Asia/Omsk" to "Asia/Omsk",
        "Asia/Oral" to "Asia/Oral",
        "Asia/Phnom_Penh" to "Asia/Phnom_Penh",
        "Asia/Pontianak" to "Asia/Pontianak",
        "Asia/Pyongyang" to "Asia/Pyongyang",
        "Asia/Qatar" to "Asia/Qatar",
        "Asia/Qostanay" to "Asia/Qostanay",
        "Asia/Qyzylorda" to "Asia/Qyzylorda",
        "Asia/Riyadh" to "Asia/Riyadh",
        "Asia/Sakhalin" to "Asia/Sakhalin",
        "Asia/Samarkand" to "Asia/Samarkand",
        "Asia/Seoul" to "Asia/Seoul",
        "Asia/Shanghai" to "Asia/Shanghai",
        "Asia/Singapore" to "Asia/Singapore",
        "Asia/Srednekolymsk" to "Asia/Srednekolymsk",
        "Asia/Taipei" to "Asia/Taipei",
        "Asia/Tashkent" to "Asia/Tashkent",
        "Asia/Tbilisi" to "Asia/Tbilisi",
        "Asia/Tehran" to "Asia/Tehran",
        "Asia/Thimphu" to "Asia/Thimphu",
        "Asia/Tokyo" to "Asia/Tokyo",
        "Asia/Tomsk" to "Asia/Tomsk",
        "Asia/Ulaanbaatar" to "Asia/Ulaanbaatar",
        "Asia/Urumqi" to "Asia/Urumqi",
        "Asia/Ust-Nera" to "Asia/Ust-Nera",
        "Asia/Vientiane" to "Asia/Vientiane",
        "Asia/Vladivostok" to "Asia/Vladivostok",
        "Asia/Yakutsk" to "Asia/Yakutsk",
        "Asia/Yangon" to "Asia/Yangon",
        "Asia/Yekaterinburg" to "Asia/Yekaterinburg",
        "Asia/Yerevan" to "Asia/Yerevan",
        "Atlantic/Azores" to "Atlantic/Azores",
        "Atlantic/Bermuda" to "Atlantic/Bermuda",
        "Atlantic/Canary" to "Atlantic/Canary",
        "Atlantic/Cape_Verde" to "Atlantic/Cape_Verde",
        "Atlantic/Faroe" to "Atlantic/Faroe",
        "Atlantic/Madeira" to "Atlantic/Madeira",
        "Atlantic/Reykjavik" to "Atlantic/Reykjavik",
        "Atlantic/South_Georgia" to "Atlantic/South_Georgia",
        "Atlantic/St_Helena" to "Atlantic/St_Helena",
        "Atlantic/Stanley" to "Atlantic/Stanley",
        "Australia/Adelaide" to "Australia/Adelaide",
        "Australia/Brisbane" to "Australia/Brisbane",
        "Australia/Broken_Hill" to "Australia/Broken_Hill",
        "Australia/Darwin" to "Australia/Darwin",
        "Australia/Eucla" to "Australia/Eucla",
        "Australia/Hobart" to "Australia/Hobart",
        "Australia/Lindeman" to "Australia/Lindeman",
        "Australia/Lord_Howe" to "Australia/Lord_Howe",
        "Australia/Melbourne" to "Australia/Melbourne",
        "Australia/Perth" to "Australia/Perth",
        "Australia/Sydney" to "Australia/Sydney",
        "Europe/Amsterdam" to "Europe/Amsterdam",
        "Europe/Andorra" to "Europe/Andorra",
        "Europe/Astrakhan" to "Europe/Astrakhan",
        "Europe/Athens" to "Europe/Athens",
        "Europe/Belgrade" to "Europe/Belgrade",
        "Europe/Berlin" to "Europe/Berlin",
        "Europe/Bratislava" to "Europe/Bratislava",
        "Europe/Brussels" to "Europe/Brussels",
        "Europe/Bucharest" to "Europe/Bucharest",
        "Europe/Budapest" to "Europe/Budapest",
        "Europe/Busingen" to "Europe/Busingen",
        "Europe/Chisinau" to "Europe/Chisinau",
        "Europe/Copenhagen" to "Europe/Copenhagen",
        "Europe/Dublin" to "Europe/Dublin",
        "Europe/Gibraltar" to "Europe/Gibraltar",
        "Europe/Guernsey" to "Europe/Guernsey",
        "Europe/Helsinki" to "Europe/Helsinki",
        "Europe/Isle_of_Man" to "Europe/Isle_of_Man",
        "Europe/Istanbul" to "Europe/Istanbul",
        "Europe/Jersey" to "Europe/Jersey",
        "Europe/Kaliningrad" to "Europe/Kaliningrad",
        "Europe/Kiev" to "Europe/Kiev",
        "Europe/Kirov" to "Europe/Kirov",
        "Europe/Lisbon" to "Europe/Lisbon",
        "Europe/Ljubljana" to "Europe/Ljubljana",
        "Europe/London" to "Europe/London",
        "Europe/Luxembourg" to "Europe/Luxembourg",
        "Europe/Madrid" to "Europe/Madrid",
        "Europe/Malta" to "Europe/Malta",
        "Europe/Mariehamn" to "Europe/Mariehamn",
        "Europe/Minsk" to "Europe/Minsk",
        "Europe/Monaco" to "Europe/Monaco",
        "Europe/Moscow" to "Europe/Moscow",
        "Europe/Oslo" to "Europe/Oslo",
        "Europe/Paris" to "Europe/Paris",
        "Europe/Podgorica" to "Europe/Podgorica",
        "Europe/Prague" to "Europe/Prague",
        "Europe/Riga" to "Europe/Riga",
        "Europe/Rome" to "Europe/Rome",
        "Europe/Samara" to "Europe/Samara",
        "Europe/San_Marino" to "Europe/San_Marino",
        "Europe/Sarajevo" to "Europe/Sarajevo",
        "Europe/Saratov" to "Europe/Saratov",
        "Europe/Simferopol" to "Europe/Simferopol",
        "Europe/Skopje" to "Europe/Skopje",
        "Europe/Sofia" to "Europe/Sofia",
        "Europe/Stockholm" to "Europe/Stockholm",
        "Europe/Tallinn" to "Europe/Tallinn",
        "Europe/Tirane" to "Europe/Tirane",
        "Europe/Ulyanovsk" to "Europe/Ulyanovsk",
        "Europe/Uzhgorod" to "Europe/Uzhgorod",
        "Europe/Vaduz" to "Europe/Vaduz",
        "Europe/Vatican" to "Europe/Vatican",
        "Europe/Vienna" to "Europe/Vienna",
        "Europe/Vilnius" to "Europe/Vilnius",
        "Europe/Volgograd" to "Europe/Volgograd",
        "Europe/Warsaw" to "Europe/Warsaw",
        "Europe/Zagreb" to "Europe/Zagreb",
        "Europe/Zaporozhye" to "Europe/Zaporozhye",
        "Europe/Zurich" to "Europe/Zurich",
        "Indian/Antananarivo" to "Indian/Antananarivo",
        "Indian/Chagos" to "Indian/Chagos",
        "Indian/Christmas" to "Indian/Christmas",
        "Indian/Cocos" to "Indian/Cocos",
        "Indian/Comoro" to "Indian/Comoro",
        "Indian/Kerguelen" to "Indian/Kerguelen",
        "Indian/Mahe" to "Indian/Mahe",
        "Indian/Maldives" to "Indian/Maldives",
        "Indian/Mauritius" to "Indian/Mauritius",
        "Indian/Mayotte" to "Indian/Mayotte",
        "Indian/Reunion" to "Indian/Reunion",
        "Pacific/Apia" to "Pacific/Apia",
        "Pacific/Auckland" to "Pacific/Auckland",
        "Pacific/Bougainville" to "Pacific/Bougainville",
        "Pacific/Chatham" to "Pacific/Chatham",
        "Pacific/Chuuk" to "Pacific/Chuuk",
        "Pacific/Easter" to "Pacific/Easter",
        "Pacific/Efate" to "Pacific/Efate",
        "Pacific/Enderbury" to "Pacific/Enderbury",
        "Pacific/Fakaofo" to "Pacific/Fakaofo",
        "Pacific/Fiji" to "Pacific/Fiji",
        "Pacific/Funafuti" to "Pacific/Funafuti",
        "Pacific/Galapagos" to "Pacific/Galapagos",
        "Pacific/Gambier" to "Pacific/Gambier",
        "Pacific/Guadalcanal" to "Pacific/Guadalcanal",
        "Pacific/Guam" to "Pacific/Guam",
        "Pacific/Honolulu" to "Pacific/Honolulu",
        "Pacific/Kanton" to "Pacific/Kanton",
        "Pacific/Kiritimati" to "Pacific/Kiritimati",
        "Pacific/Kosrae" to "Pacific/Kosrae",
        "Pacific/Kwajalein" to "Pacific/Kwajalein",
        "Pacific/Majuro" to "Pacific/Majuro",
        "Pacific/Marquesas" to "Pacific/Marquesas",
        "Pacific/Midway" to "Pacific/Midway",
        "Pacific/Nauru" to "Pacific/Nauru",
        "Pacific/Niue" to "Pacific/Niue",
        "Pacific/Norfolk" to "Pacific/Norfolk",
        "Pacific/Noumea" to "Pacific/Noumea",
        "Pacific/Pago_Pago" to "Pacific/Pago_Pago",
        "Pacific/Palau" to "Pacific/Palau",
        "Pacific/Pitcairn" to "Pacific/Pitcairn",
        "Pacific/Pohnpei" to "Pacific/Pohnpei",
        "Pacific/Port_Moresby" to "Pacific/Port_Moresby",
        "Pacific/Rarotonga" to "Pacific/Rarotonga",
        "Pacific/Saipan" to "Pacific/Saipan",
        "Pacific/Tahiti" to "Pacific/Tahiti",
        "Pacific/Tarawa" to "Pacific/Tarawa",
        "Pacific/Tongatapu" to "Pacific/Tongatapu",
        "Pacific/Wake" to "Pacific/Wake",
        "Pacific/Wallis" to "Pacific/Wallis",
        "UTC" to "UTC",
    )
}
